// test2270
(2270 && 0);
